import type { FullUserResponse } from "@/redux/users/types";
import { OrganizationRoleValue, Roles } from "@/shared/utils/constants";

export function getUserRoleBadgeName(
  user: FullUserResponse,
): OrganizationRoleValue | undefined {
  if (user.organizationRole) return user.organizationRole;
  if (user.role === Roles.ADMIN.value) return Roles.ADMIN.value;
  return undefined;
}
